import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { StorageService } from '../../../providers/storage.service';

/**
 * Generated class for the PgPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-pg',
  templateUrl: 'pg.html',
})
export class PgPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storage: StorageService,
  ) {
    let obj = this.storage.read('ThirdCode');
    this.storage.remove('ThirdCode');
    // window.document.write(obj.toString());
    const win = window.document;
    win.open();
    win.write(obj.toString());
    win.close();   
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/pg/pg.ts